import React from 'react'
import Helper from 'src/support/Helper';

const OrderDetailViewAllTrackingPopup = (props) => {
    const { SetStatus, data } = props;
    const getTrackingCarrierLink = (orderDetail,trackingNumber) => {
        if(orderDetail!==undefined && orderDetail!==null && 
            orderDetail.carrier!==undefined &&
            orderDetail.carrier!==null &&
            Object.keys(orderDetail.carrier).length > 0)
            {
                let trackingCarrier = orderDetail.carrier[trackingNumber];
                if(trackingCarrier!==undefined && trackingCarrier!==null)
                {
                    let carrier= Helper.getTrackingCarrier(trackingCarrier.carrier); // considering first item carrier
                    if(carrier !== '')
                    {
                        const link = document.createElement('a');
                        link.href = carrier+trackingNumber;
                        link.target = '_blank';
                        link.click();
                    }
                }
            }
            return false;
    }
    return (
        <>
            <div className="avnet-modal modal-530">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal" onClick={(() => SetStatus(false))}>×</button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5">View All Tracking/WayBill Number</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body py-0">
                        <div className="clearfix" />

                        <div className='mb-3 text-center mt-4 mb-5'>
                            <div><b className='text-black'>Here are all of your Tracking/WayBill Numbers for PO Number {data.poNumber}</b></div>
                        </div>

                        <div className='m-b-30'>
                            <div className="bs5 row text-center">
                                {
                                    data.trackingData && data.trackingData.length > 0 &&
                                    data.trackingData.map((v, i) => (
                                        <div className='col-md-6 mb-1'><a href={void (0)} onClick={() => getTrackingCarrierLink(data.header_order,v)}><span className='text-blue'>{v}</span></a></div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer justify-content-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145" data-dismiss="modal" onClick={(() => SetStatus(false))}>
                                close
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OrderDetailViewAllTrackingPopup